import { render } from "./worker_speciality.vue?vue&type=template&id=ee5a995c"
import script from "./worker_speciality.vue?vue&type=script&lang=js"
export * from "./worker_speciality.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__